<script setup lang="ts">
import MapMarkerHouseIcon from "@/areas/MapMarkerHouseIcon.vue";
import BottomSheet from "@/components/BottomSheet.vue";
import MapMarkerIcon from "@/components/map/MapMarkerIcon.vue";
import { canvassHouseStatusToColor } from "./canvassHouseColor";

defineEmits<{
  close: [];
}>();
</script>

<template>
  <BottomSheet @close="$emit('close')">
    <template #title>Kartenlegende</template>
    <dl class="grid grid-xs">
      <div>
        <dt>
          <span class="visually-hidden">Blaue Markierung</span>
          <MapMarkerIcon class="map-marker-meetingpoint" />
        </dt>
        <dd>Treffpunkt</dd>
      </div>
      <div>
        <dt>
          <span class="visually-hidden">Grüne Markierung</span>
          <MapMarkerHouseIcon :color="canvassHouseStatusToColor('completed')" />
        </dt>
        <dd>abgeschlossen</dd>
      </div>
      <div>
        <dt>
          <span class="visually-hidden">Gelbe Markierung</span>
          <MapMarkerHouseIcon :color="canvassHouseStatusToColor('wip')" />
        </dt>
        <dd>Türen wurden geklopft</dd>
      </div>
      <div>
        <dt>
          <span class="visually-hidden">Graue Markierung</span>
          <MapMarkerHouseIcon :color="canvassHouseStatusToColor('pending')" />
        </dt>
        <dd>ohne Interaktion</dd>
      </div>
    </dl>
  </BottomSheet>
</template>
